import React, { useContext, useEffect, useState } from 'react';
import styles from 'routes/vendorRe/pages/common/VendorModal.module.css';
import Container from 'routes/vendorRe/containers/commons/Container';
import VerticalFlex from 'routes/vendorRe/containers/commons/VerticalFlex';
import FlexChild from 'routes/vendorRe/containers/commons/FlexChild';
import cancelIcon from 'routes/vendorRe/images/cancel_icon.png';
import useCustomMove from 'routes/vendorRe/hooks/useCustomMove';
import { AuthContext } from 'providers/AuthProvider';
import { requester } from 'App';

const VendorModal = ({ callbackFn }) => {
    const { userName, roles } = useContext(AuthContext);
    const [isMounted, setMounted] = useState(false);
    const [totalPrice, setTotalPrice] = useState();
    const {
        moveToStats,
        moveToCalc,
        moveToSale,
        moveToDevice,
        moveToError,
        moveToCctv,
    } = useCustomMove();
    useEffect(() => {
        setMounted(true);
    }, [])
    useEffect(() => {
        if (isMounted) {
            requester.getVendorSettlementFee((result) => {
                setTotalPrice(result.data.totalPrice);
                
            })
        }
    }, [isMounted])

    return (
        <div className={styles.layer}>
            <div className={styles.popup}>
                <Container>
                    <VerticalFlex>
                        <FlexChild backgroundColor="#FE531F" alignItems="flex-start" padding="2em" flex="1" justifyContent="space-around">
                            <VerticalFlex flexStart gap={10}>
                                <FlexChild alignItems={"flex-end"}>
                                    <img onClick={() => {
                                        if (callbackFn) {
                                            callbackFn();
                                        }
                                    }} className={styles.cancel} src={cancelIcon} alt="취소 아이콘" />
                                </FlexChild>
                                <FlexChild>
                                    <p className={styles.pTag}>
                                        {userName ? userName : "NONE"}
                                    </p>
                                </FlexChild>
                                <FlexChild>
                                    <p style={{ fontSize: "min(3.4vw, 12px)", color: "white" }}>{roles ? roles : "NONE"}</p>
                                </FlexChild>
                                <FlexChild>
                                    <p className={styles.pTag}>
                                        <span style={{ marginRight: "1em" }}>이달의 매출</span>
                                        <span className={styles.bold}>{totalPrice ? totalPrice.toLocaleString() : 0}원</span>
                                    </p>
                                </FlexChild>
                            </VerticalFlex>
                        </FlexChild>
                        <FlexChild flex="5">
                            <VerticalFlex>
                                <FlexChild padding="2em">
                                    {/* <div className={styles.menuDiv}
                                        onClick={() => {
                                            moveToSale();
                                            if (callbackFn) {
                                                callbackFn();
                                            }
                                        }}>판매 내역 조회</div> */}
                                    <div className={styles.menuDiv}
                                        onClick={() => {
                                            moveToCalc();
                                            if (callbackFn) {
                                                callbackFn();
                                            }
                                        }}>정산 금액 조회</div>
                                    <div className={styles.menuDiv}
                                        onClick={() => {
                                            moveToStats();
                                            if (callbackFn) {
                                                callbackFn();
                                            }
                                        }}>매출 &middot; 판매 통계</div>
                                    {/* <div className={styles.menuDiv}
                                        onClick={() => {
                                            moveToDevice();
                                            if (callbackFn) {
                                                callbackFn();
                                            }
                                        }}>매장 기기 관리</div> */}
                                    {/* <div className={styles.menuDiv}
                                        onClick={() => {
                                            moveToError();
                                            if (callbackFn) {
                                                callbackFn();
                                            }
                                        }}>오류 접수</div> */}
                                    <div className={styles.menuDiv}
                                        onClick={() => {
                                            moveToCctv();
                                            if (callbackFn) {
                                                callbackFn();
                                            }
                                        }}>CCTV 관리</div>
                                </FlexChild>
                            </VerticalFlex>
                        </FlexChild>
                    </VerticalFlex>
                </Container>
            </div>
        </div>
    );
};

export default VendorModal;